var _class;
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component, Fragment } from "react";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import Box from "../../../Styled/Box";
import Spacing from "../../../Styled/Spacing";
import Text from "../../../Styled/Text";
import Collapsible from "../../Custom/Collapsible/Collapsible";
import parseCustomMarkdownToReact from "../../Custom/parseCustomMarkdownToReact";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let ShortReport = observer(_class = class ShortReport extends Component {
  clickShortReport(item, reportName, isOpen) {
    const shortReportSections = item.shortReportSections;
    const clickedReport = shortReportSections.find(report => report.name === reportName);
    if (isDefined(clickedReport)) {
      runInAction(() => {
        /**
         * Ensure short report order is reflected by all strata up to this point
         * & replicate all onto user stratum so that toggling doesn't re-order
         * reports - a stopgap for the lack of consistent behavior surrounding
         * removals / re-ordering of objectArrayTraits
         */
        shortReportSections.forEach(report => report.setTrait(CommonStrata.user, "show", report.show));
        clickedReport.setTrait(CommonStrata.user, "show", isOpen);
      });
    }
    return false;
  }
  render() {
    var _item$shortReportSect;
    if (!CatalogMemberMixin.isMixedInto(this.props.item)) return null;
    const item = this.props.item;
    const shortReportSections = (_item$shortReportSect = item.shortReportSections) === null || _item$shortReportSect === void 0 ? void 0 : _item$shortReportSect.filter(r => isDefined(r.name));
    if ((!isDefined(item.shortReport) || item.shortReport === "") && (!isDefined(shortReportSections) || shortReportSections.length === 0)) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Box, {
      fullWidth: true,
      displayInlineBlock: true,
      children: [isDefined(item.shortReport) && /*#__PURE__*/_jsx(Text, {
        textGreyLighter: true,
        medium: true,
        children: parseCustomMarkdownToReact(item.shortReport, {
          catalogItem: item
        })
      }), shortReportSections.filter(r => r.name).map((r, i) => /*#__PURE__*/_jsxs(Fragment, {
        children: [r.content ? /*#__PURE__*/_jsx(Collapsible, {
          title: r.name,
          isOpen: r.show,
          onToggle: show => this.clickShortReport(item, r.name, show),
          children: parseCustomMarkdownToReact(r.content, {
            catalogItem: item
          })
        }) : /*#__PURE__*/_jsx(Text, {
          textGreyLighter: true,
          medium: true,
          children: parseCustomMarkdownToReact(r.name, {
            catalogItem: item
          })
        }), i < shortReportSections.length - 1 && /*#__PURE__*/_jsx(Spacing, {
          bottom: 2
        })]
      }, r.name))]
    });
  }
}) || _class;
export { ShortReport as default };